var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0808105,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FFAC06",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141 20H20.0808V15",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142 20C28.4142 24.6023 24.6832 28.3333 20.0808 28.3333C15.4785 28.3333 11.7475 24.6023 11.7475 20C11.7475 15.3976 15.4785 11.6667 20.0808 11.6667",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7871 13.4753C25.9322 13.6035 26.0734 13.7363 26.2104 13.8733C26.3474 14.0104 26.4801 14.1517 26.6081 14.2969M22.5808 11.6667C22.9826 11.7855 23.3765 11.9386 23.7586 12.1222M27.9454 16.2955C28.1347 16.6859 28.2924 17.0889 28.4141 17.5",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPending);
export default __webpack_public_path__ + "static/media/total-pending.d2c753b8cfd298af986f8496a3fd6a42.svg";
export { ForwardRef as ReactComponent };